import { isLoggedInState } from "@/atoms/accountState";
import { DevWarningBanner, useResponsive, VStack } from "goi_common";
import { useRouter } from "next/router";
import React, { useEffect, useMemo } from "react";
import { useRecoilValue } from "recoil";

import GuidebookSummaryHeader from "./GuidebookSummaryHeader";

import { useDisclosure } from "@chakra-ui/react";
import StepGuideFooter from "../common/StepGuideFooter";

import { Header } from "./Header";

import Menu from "./Menu";

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const router = useRouter();
  const { isBiggerThanMd } = useResponsive();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const isGuideBookSummary = useMemo(() => {
    return router.asPath.startsWith("/guidebook/summary/");
  }, [router]);

  const isHeaderHidden = useMemo(() => {
    return (
      router.route === "/login" ||
      router.route === "/login-redirect" ||
      isGuideBookSummary ||
      router.asPath.startsWith("/partners/") ||
      router.asPath.startsWith("/hospice/") ||
      router.asPath.startsWith("/care/")
    );
  }, [router]);

  const isChecklistFabVisible = useMemo(() => {
    if (router.route.startsWith("/guidebook")) {
      return true;
    }

    const checklistPages = ["/care/region/[code]", "/hospice/[id]"];

    return checklistPages.includes(router.pathname);
  }, [router]);

  const isLoggedIn = useRecoilValue(isLoggedInState);

  const quotationRequestCRMDrawerOpen = () => {
    const isLoginPath = router.asPath.startsWith("/login");

    if (isLoggedIn || isLoginPath) return;
  };

  useEffect(() => {
    quotationRequestCRMDrawerOpen();
  }, [router.asPath]);

  const getChecklistFabBottomOffset = useMemo(() => {
    const pageOffsets: Record<string, { md: string; mobile: string }> = {
      "/care/region/[code]": { md: "38px", mobile: "38px" },
      "/hospice/[id]": { md: "38px", mobile: "38px" },
    };

    if (pageOffsets[router.route]) {
      const offset = pageOffsets[router.route];
      return isBiggerThanMd ? offset.md : offset.mobile;
    }

    return "72px";
  }, [router.route, isBiggerThanMd]);

  return (
    <>
      {!(process.env.NEXT_PUBLIC_IS_PRODUCTION === "true") && (
        <DevWarningBanner />
      )}
      {!isHeaderHidden && <Header onOpen={onOpen} />}
      {isGuideBookSummary && <GuidebookSummaryHeader />}
      <VStack>{children}</VStack>
      {isChecklistFabVisible && (
        <StepGuideFooter
          text={
            <>
              장례가 처음이신가요? 합리적인 장례,
              <br />
              차근차근 알려드릴게요.
            </>
          }
          size="30px"
          src="/step-guide/facility-initiation/"
          event={{
            newGtm: {
              path: "step_guide",
              trigger_and_target: "step_guide_fixed_button",
            },
          }}
          maxWidth="100%"
          bottom={getChecklistFabBottomOffset}
        />
      )}

      <Menu isOpen={isOpen} onClose={onClose} />
    </>
  );
}
